import { QueryConfig } from "store/utils/query-config";

export const productsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
